export const parseLocalizedName = (value, language, fallback = "N/A") => {
  if (value == null || value === "") return fallback;

  if (typeof value === "object") {
    return (
      value[language] ||
      value.en ||
      value.ku ||
      value.ar ||
      Object.values(value).find((entry) => typeof entry === "string" && entry.trim()) ||
      fallback
    );
  }

  if (typeof value !== "string") return String(value);

  try {
    if (!value.trim().startsWith("{")) {
      return value;
    }

    const parsed = JSON.parse(value);
    if (typeof parsed !== "object" || parsed === null) {
      return fallback;
    }

    return (
      parsed[language] ||
      parsed.en ||
      parsed.ku ||
      parsed.ar ||
      Object.values(parsed).find(Boolean) ||
      fallback
    );
  } catch {
    return value;
  }
};
